import React from 'react'

import Translate from '../../Translate'

const ArticlesGroupingLabel = () => (
  <Translate i18nString="Include complete text from similar articles and not just source reference" />
)

export default ArticlesGroupingLabel
